
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { getReservationCalendar } from '@/api/reservationItem';
import { getStayCalendarInfo } from '@/api/stay';

@Component({
  name: 'Calendar',
})
export default class extends Vue {
  // private today = new Date();

  // private todayYear = new Date().getFullYear();

  // private todayMonth = new Date().getMonth() + 1;

  @Prop({ required: true }) private today!: any;

  @Prop({ required: true }) private todayYear!: any;

  @Prop({ required: true }) private todayMonth!: any;

  @Prop({ required: false }) private selectedRoom!: any;

  @Prop({ required: false }) private readMode!: any;

  // 요금 달력·방막기/풀기에서만 이벤트 적용가 표시 (예약 달력은 기존 그대로)
  @Prop({ required: false, default: false }) private showEventPrice!: boolean;

   private calendarData: any = [];

   mounted() {
     this.getStayCalendar(moment().format('YYYY-MM'));
     this.getCalendarInfo();
   }

  private calendarDataClone: any = null;

  private str = '';

  private startDate: Date | null = null;

  private endDate: Date | null = null;

  private count = 0;

  @Watch('today')
  private getCalendar() {
    this.$nextTick(() => {
      this.changeCalendar(this.today);
    });
  }

  @Watch('calendarData', { deep: true })
  private getCalendarInfo() {
    this.$nextTick(() => {
      this.currentCalendar();
    });
  }

  @Watch('selectedRoom', { deep: true })
  private checkedRoom() {
    this.$nextTick(() => {
      if (this.selectedRoom.checkFlag) {
        const dowDivs = (document.getElementById('calendar') as HTMLTableElement).querySelectorAll('.dow');
        dowDivs.forEach((dowDiv:any) => {
          const date = dowDiv.getAttribute('data-date');
          if (this.selectedRoom.date === date) {
            const roomDivs = dowDiv.parentNode.querySelectorAll('.room');
            roomDivs.forEach((roomDiv:any) => {
              const id = roomDiv.getAttribute('data-id');
              if (this.selectedRoom.id === id) {
                const checkbox = roomDiv.querySelector('input[type="checkbox"]');
                if (checkbox.checked) checkbox.checked = false;
                else checkbox.checked = true;
                this.selectedRoom.checkFlag = false;
              }
            });
          }
        });
      }
    });
  }

  private reloadCalendar() {
    this.changeCalendar(this.today);
  }

  private async currentCalendar() {
    const firstDate = new Date(this.todayYear, this.todayMonth - 1, 1);
    const lastDate = new Date(this.todayYear, this.todayMonth, 0);
    const nextDate = new Date(this.todayYear, this.todayMonth, 1);
    let tbodyCalendar: any = (document.getElementById('calendar') as HTMLTableElement).tBodies[0];
    if (tbodyCalendar === undefined) tbodyCalendar = document.getElementById('calendar') as HTMLTableElement;

    while (tbodyCalendar.rows.length > 0) tbodyCalendar.deleteRow(tbodyCalendar.rows.length - 1);

    let row = null;
    row = tbodyCalendar.insertRow();

    let count = 0;

    for (let i = 0; i < firstDate.getDay(); i += 1) {
      const cell = row.insertCell();
      cell.classList.add('none');
      count += 1;
    }
    for (let i = 1; i <= lastDate.getDate(); i += 1) {
      count += 1;
      let dow = '';
      let holiday = '';
      if (count % 7 === 1) dow = '일';
      else if (count % 7 === 2) dow = '월';
      else if (count % 7 === 3) dow = '화';
      else if (count % 7 === 4) dow = '수';
      else if (count % 7 === 5) dow = '목';
      else if (count % 7 === 6) dow = '금';
      else if (count % 7 === 0) dow = '토';

      // eslint-disable-next-line @typescript-eslint/no-inferrable-types
      const compareDay = `${firstDate.getFullYear()}-${firstDate.getMonth() + 1}-${i}`;
      const datePattern = 'YYYY-MM-DD';

      const day = moment(compareDay, datePattern).format(datePattern);
      const dataIndex = this.calendarData.findIndex((data: any) => data.date === day);
      const dateInfo = this.calendarData[dataIndex];

      if (count % 7 === 1 || count % 7 === 6 || count % 7 === 0) holiday = '주말';
      else holiday = '주중';

      if (dateInfo.holidayStatus === 1) {
        holiday = '공휴일';
      } else if (dateInfo.holidayStatus === 2) {
        holiday = '공휴일 전날';
      }

      const clickDate: string = `${firstDate.getFullYear()}.${firstDate.getMonth() + 1}.${i}`;

      const cell = row.insertCell();
      this.str = `<div class="dow" data-date="${dateInfo.date}">${dow}요일</div>`;
      this.str += `<div class="item cell__date" id="cell-${firstDate.getMonth() + 1}-${i}">`;
      this.str += '  <div class="info-head">';
      this.str += `    <div class="day">${i}</div>`;
      this.str += `    <div class="txt">${dateInfo.pricePartName} ${holiday}</div>`;
      this.str += '  </div>';
      if (this.showEventPrice && dateInfo.eventDiscountPercent > 0) this.str += `  <div class="event-rate">이벤트 ${dateInfo.eventDiscountPercent}% 할인</div>`;
      this.str += '  <div class="info-room">';

      dateInfo.roomList.forEach((room: any) => {
        let type = '';
        if (room.closeStatus) type = 'disable';
        if (room.reserveStatus) type = 'full';
        if (!room.closeStatus && !room.reserveStatus) type = 'available';
        this.str += `    <div class="room" data-id="${room.roomIdx}"">`;
        this.str += `       <span class="status reserve-state__${type} gft">`;
        if (type === 'disable') this.str += '<i class="icon"></i>';
        this.str += '       </span>';
        this.str += '       <div class="txt">';
        this.str += `         <span class="room-name">${room.roomName}</span>`;
        this.str += `         <span>${room.price.toLocaleString()}원</span>`;
        if (this.showEventPrice && room.eventPrice != null) this.str += `         <span class="event-price">이벤트가 ${room.eventPrice.toLocaleString()}원</span>`;
        this.str += '       </div>';
        this.str += '    </div>';
      });

      this.str += '  </div>';
      this.str += '</div>';
      cell.classList.add('date-cell');
      cell.innerHTML = this.str;
      this.str = '';

      const dayNumber = count % 7;

      if (count % 7 === 1) cell.classList.add('sun');
      if (count % 7 === 0) {
        cell.classList.add('sat');
        row = tbodyCalendar.insertRow();
      }

      if (dateInfo.holidayStatus === 1) {
        cell.classList.add('holiday');
      }

      // room 이라는 div에 클릭 이벤트를 추가하는 부분
      const roomDivs = cell.querySelectorAll('.room');

      if (roomDivs) {
        roomDivs.forEach((roomDiv:any) => {
          if (roomDiv.querySelectorAll('.reserve-state__full').length < 1) {
            roomDiv.addEventListener('click', this.handleRoomClick);
          }
        });
      }
    }
    if (nextDate.getDay() !== 0) {
      for (let i = 0; i < 7 - nextDate.getDay(); i += 1) {
        const cell = row.insertCell();
        cell.classList.add('none');
        count += 1;
      }
    }

    // 빈 td 높이조정
    const dateCells = (document.getElementById('calendar') as HTMLTableElement).querySelectorAll('.date-cell');
    const height = (dateCells[0] as HTMLElement).offsetHeight;
    const noneList = (document.getElementById('calendar') as HTMLTableElement).querySelectorAll('.none');
    noneList.forEach((item:any) => {
      item.style.height = `${height}px`;
    });
  }

  /* eslint-disable */
  private handleRoomClick(event: any) {
    const roomIdx = event.currentTarget.getAttribute('data-id');
    const date = event.currentTarget.parentNode.parentNode.parentNode.querySelector('.dow').getAttribute('data-date');
    const roomName = event.currentTarget.querySelector('.room-name').innerHTML;
    const className = event.currentTarget.querySelector('.status').className;
    let closeStatus = true;
    if (className.includes('reserve-state__disable')) closeStatus = false;
    // this.$emit('handleConfirmVisible', roomIdx, dataDate, closeStatus);

    const roomInfo = {
      roomIdx,
      roomName,
      date,
      closeStatus,
    }
    this.$emit('click-room', roomInfo);
  }

  private clickPrevMonth() {
    if (this.todayMonth === 1) {
      this.todayMonth = 12;
      this.today = new Date(this.today.getFullYear() - 1, 11, 1);
    } else {
      this.todayMonth -= 1;
      this.today = new Date(this.today.getFullYear(), this.todayMonth - 1, 1);
    }
    this.changeCalendar(this.today);
  }

  private clickNextMonth() {
    if (this.todayMonth === 12) {
      this.todayMonth = 1;
      this.today = new Date(this.today.getFullYear() + 1, 0, 1);
    } else {
      this.todayMonth += 1;
      if (this.todayMonth === 12) this.today = new Date(this.today.getFullYear(), 11, 1);
      else this.today = new Date(this.today.getFullYear(), this.todayMonth - 1, 1);
    }
    this.changeCalendar(this.today);
  }

  private changeCalendar(today: any) {
    this.todayYear = today.getFullYear();
    this.getStayCalendar(moment(`${this.todayYear}-${this.todayMonth}`, 'YYYY-MM').format('YYYY-MM'));
  }

  private loading = false;

  private getStayCalendar(selectedMonth: string) {
    this.loading = true;
    getStayCalendarInfo({ searchMonth: selectedMonth }).then((res) => {
      this.calendarData = res.data;
      this.loading = false;
    });
  }
}
